<template>
  <div v-if="data">
    <p class="mt-8 mb-4">
      <span class="font-bold mr-4">{{ $t("收货地址") }}</span>
      <span class="text-gray-400 text-sm">
        <!-- {{ $t("您已经创建") }}
        <span>{{ data.items.length }}</span>
        {{ $t("个收货地址，最多可建50个") }} -->
        {{ $t('您已经创建{num}个收货地址，最多可建50个').replace("{num}", data.items.length) }}
      </span>
    </p>
    <div>
      <List :span="2" :data="data" v-slot="{ item }">
        <Radio
          class="w-full h-7rem py-2 px-1px show"
          :item="item"
          v-model="select.v"
        >
          <div class="text-left px-4">
            <p class="flex items-center">
              <span class="name">{{ item.receiver }}</span>
              <span class="text-gray-400 ml-4 phone">{{ item.phone }}</span>
              <template v-if="item.isdefault">
                <span class="bg-mainHigh text-white text-xs px-1 ml-8">{{
                  $t("默认")
                }}</span>
              </template>
            </p>
            <p class="flex flex-nowrap space-x-2 text_display">
              <span v-if="item.area">{{ item.area.names }}</span>
              <span>{{ item.address }}</span>
            </p>
            <p class="space-x-5 text-gray-400 text-sm mt-1 invisible disp">
              <span @click.stop="modify(item)">
                <i class="iconfont icon-bianji"></i>
                {{ $t("修改") }}
              </span>
              <span @click.stop="setDefault(item)">{{ $t("设为默认") }}</span>
              <span
                class="
                  iconfont
                  icon-shanchu
                  inline-block
                  transform
                  scale-90
                  translate-y-1.2px
                "
                @click="remove(item.id)"
              ></span>
            </p>
          </div>
        </Radio>
      </List>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-dom";
import Radio from "@/components/base/radio.vue";
import List from "@/components/base/list.vue";

import { onUpdated, reactive } from "@vue/composition-api";
export default defineComponent({
  components: { Radio, List },
  props: { data: Object },
  setup(props, ctx) {
    const select = reactive({ v: null });
    onUpdated(() => {
      select.v = props.data.items[0]?.id;
    });
    const remove = async (value) => {
      await ctx.root.$callapi("user/doAddressAction", {
        address_id: value,
        _action: "del",
      });
      ctx.emit("remove");
    };
    const setDefault = async (item) => {
      item.isdefault = true;
      item.aid = item.id;
      await ctx.root.$callapi("user/saveAddress", item);
      ctx.emit("setDefault");
    };
    const modify = (item) => {
      ctx.emit("modify", item.id);
    };
    return { select, remove, setDefault, modify };
  },
});
</script>

<style scoped lang="scss">.show:hover .disp {
  visibility: visible;
}
.text_display {
  overflow: hidden;
  width: 100%;
  height: 3rem;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}</style>
